
import Vue, { VNode } from "vue";

interface ColorPage {
  fill(el: SVGPathElement, color: string): void;
}
interface UndoState {
  el: SVGPathElement;
  color: string;
  prevColor: string;
}

interface Data {
  undo: UndoState[];
  redo: UndoState[];
}

function isColorPage(el: unknown): el is ColorPage {
  if (Object.prototype.hasOwnProperty.call(el, "fill")) {
    return true;
  }
  return false;
}

export default Vue.extend({
  data(): Data {
    return {
      undo: [],
      redo: []
    };
  },
  methods: {
    onUserFill(e: UndoState): void {
      this.undo.push(e);
      this.redo = [];
      this.emitUndo();
      this.emitRedo();
    },
    onUndo(): void {
      const colorPage = this.getColorPage();
      if (this.undo.length > 0 && colorPage) {
        const undoState = this.undo.pop() as UndoState;
        colorPage.fill(undoState.el, undoState.prevColor);
        this.redo.push(undoState);
        this.emitUndo();
        this.emitRedo();
      }
    },
    onRedo(): void {
      const colorPage = this.getColorPage();
      if (this.redo.length > 0 && colorPage) {
        const undoState = this.redo.pop() as UndoState;
        colorPage.fill(undoState.el, undoState.color);
        this.undo.push(undoState);
        this.emitUndo();
        this.emitRedo();
      }
    },
    getColorPage(): ColorPage | undefined {
      if (this.$children.length == 1) {
        const slot: unknown = this.$children[0];
        if (isColorPage(slot)) {
          return slot;
        }
      }
      return;
    },
    emitUndo() {
      this.$emit("undoStateChange", this.undo.length);
    },
    emitRedo() {
      this.$emit("redoStateChange", this.redo.length);
    }
  },
  render(h): VNode {
    const slot = this.$scopedSlots.default;
    if (slot != undefined) {
      const contents = slot({
        onUserFill: this.onUserFill,
        onRedo: this.onRedo,
        onUndo: this.onUndo
      });
      if (contents && contents.length > 0) {
        return contents[0];
      }
    }
    return h();
  }
});
